import { GetCookie } from "../utils/base"
export default {
    state: {
        test: false,
        isDark: GetCookie('dark') === '1'
    },
    mutations: {
        test (state, action) {
            state.isDark = action
        },
        darkUpdate (state, action) {
            const bool = (action === '1');
            state.isDark = bool
        }
    },
    actions: {
        // 初始化胜平负连赢数据
        async test  (store, param) {}
    }
}
